


















import { Component, Prop } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { LoginState } from '@/views/pages/auth/Login.vue';

@Component({ name: 'login-loading', components: {} })
export default class LoginLoading extends mixins(BaseMixin) {
  @Prop({ default: false }) loginState!: LoginState;

  get stateLoading() {
    return this.loginState === LoginState.LOADING;
  }

  get stateLoggingIn() {
    return this.loginState === LoginState.LOGGING_IN;
  }

  get stateSuccess() {
    return this.loginState === LoginState.SUCCESS;
  }

  get stateLoggedIn() {
    return this.loginState === LoginState.LOGGED_IN;
  }

  get stateLoginProcess() {
    return this.loginState === LoginState.LOADING || this.loginState === LoginState.LOGGING_IN;
  }

  get greetings() {
    const hourOfDay = new Date().getHours();

    let greetings = [
      'Hey',
      'Hi',
      'Hallo',
      'Guten Tag',
      'Grüß Dich',
      'Salut',
      'Servus',
      'Moin',
      'Willkommen',
    ];
    if (hourOfDay < 11) {
      greetings = ['Moin', 'Guten Morgen', 'Moin Moin', 'Morgen'];
    } else if (hourOfDay > 18) {
      greetings = ['Guten Abend', 'Schönen Abend'];
    }

    return greetings[Math.floor(Math.random() * greetings.length)];
  }
}
